(() => {
  'use strict';
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mk-nav]').forEach((panel) => {
      if (panel.dataset.enhanced) return;
      const menu = panel.closest('details.nav-menu');
      if (!menu) return;
      const outerTrigger = menu.querySelector(':scope > summary');
      const departments = Array.from(panel.querySelectorAll('[data-mk-department]'));
      const triggers = departments.map((item) => item.querySelector(':scope > summary'));
      const desktop = window.matchMedia('(min-width: 769px)');
      const closeButton = panel.querySelector('[data-mk-close]');
      panel.dataset.enhanced = 'true';
      closeButton.hidden = false;
      outerTrigger.setAttribute('aria-controls', panel.id);
      const sync = () => {
        outerTrigger.setAttribute('aria-expanded', String(menu.open));
        departments.forEach((item, index) => triggers[index].setAttribute('aria-expanded', String(item.open)));
      };
      const choose = (item) => {
        departments.forEach((department) => { department.open = department === item; });
        sync();
      };
      const close = (restoreFocus = false) => {
        menu.open = false;
        sync();
        if (restoreFocus) outerTrigger.focus();
      };
      const setMode = () => {
        if (desktop.matches && departments.length) {
          choose(departments.find((item) => item.open) || departments[0]);
        } else {
          departments.forEach((item) => { item.open = false; });
          sync();
        }
      };
      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', (event) => {
          if (desktop.matches) {
            event.preventDefault();
            choose(departments[index]);
          }
        });
        trigger.addEventListener('keydown', (event) => {
          if (!desktop.matches) return;
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % triggers.length;
          if (event.key === 'ArrowUp') next = (index - 1 + triggers.length) % triggers.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = triggers.length - 1;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            choose(departments[index]);
            departments[index].querySelector('.mk-nav-category a')?.focus();
          }
          if (next !== undefined) {
            event.preventDefault();
            triggers[next].focus();
            choose(departments[next]);
          }
        });
        departments[index].addEventListener('toggle', () => {
          if (departments[index].open) {
            departments.forEach((item) => { if (item !== departments[index]) item.open = false; });
          }
          sync();
        });
      });
      panel.addEventListener('keydown', (event) => {
        if (desktop.matches && event.key === 'ArrowLeft' && event.target.closest('.mk-nav-category')) {
          event.preventDefault();
          event.target.closest('[data-mk-department]').querySelector(':scope > summary').focus();
        }
      });
      menu.addEventListener('toggle', sync);
      closeButton.addEventListener('click', () => close(true));
      document.addEventListener('pointerdown', (event) => {
        if (menu.open && !menu.contains(event.target)) close();
      });
      document.addEventListener('focusin', (event) => {
        if (menu.open && !menu.contains(event.target)) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          close(true);
        }
      });
      desktop.addEventListener('change', setMode);
      setMode();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
